module.exports = __webpack_public_path__ + "img/silent-rides.5fc3a03b.webp";